import React from "react";
import { Button, Modal, Spinner } from "react-bootstrap";

const renderValue = (value) => {
  if (value == null) return "-";
  if (typeof value === "string" || typeof value === "number") return String(value);
  return JSON.stringify(value, null, 2);
};

export default function ViewEmailAccountModal({ show, onClose, account, loading }) {
  return (
    <Modal show={show} onHide={onClose} centered backdrop="static" keyboard>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: 15 }}>Email Account Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="d-flex align-items-center justify-content-center py-4">
            <Spinner animation="border" variant="success" />
          </div>
        ) : account ? (
          <div className="d-flex flex-column gap-2">
            <div className="small text-muted">Summary</div>
            <div className="border rounded p-2 bg-light">
              <pre className="mb-0 small" style={{ whiteSpace: "pre-wrap" }}>
                {JSON.stringify(account, null, 2)}
              </pre>
            </div>
            <div className="small text-muted">Fields</div>
            <div className="d-flex flex-column gap-1">
              {Object.entries(account).map(([key, value]) => (
                <div key={key} className="small">
                  <strong>{key}:</strong> {renderValue(value)}
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="text-muted small">No data available.</div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" size="sm" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
